import { Location } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';


import { Title, Meta } from '@angular/platform-browser';
import { PdfService } from './services/pdf.service';
import { OperationService } from './services/operation.service';
import AOS from 'aos';
import { TranslateService } from '@ngx-translate/core';



declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'GAIL Gas Limited';
  currentLocation: any;
  flag: boolean = false;
  hide_popup_aftertime = true;
  // heedd: boolean = true;
  // fooot: boolean = true;

  constructor(private operationService: OperationService, private router: Router, private location: Location, public dialog: MatDialog, private titleService: Title, private metaTagService: Meta, private PdfService: PdfService, private cdRef: ChangeDetectorRef) {
    this.cng_rates()
    this.png_rates()
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //scroll to top
        window.scrollTo(0, 0);
      }
    });

    // this.openDialog();
    console.log(window.innerWidth, window.innerHeight)
    this.currentLocation = this.location.path();
    console.log(this.currentLocation);
    var lang;
    if (this.currentLocation.includes('/home-hn') || this.currentLocation.includes('/onlinecomplaint-hn') || this.currentLocation.includes('/complaints-hn')  || this.currentLocation.includes('/about/overview-hn') || this.currentLocation.includes('/careers-in-hn') || this.currentLocation.includes('/products/png-hn') || this.currentLocation.includes('/products/cng-hn') || this.currentLocation.includes('/hse-hn') || this.currentLocation.includes('/eoi-hn') || this.currentLocation.includes('/contact-hn') || this.currentLocation.includes('/meerut-hn') || this.currentLocation.includes('/sonipat-hn') || this.currentLocation.includes('/trapezium-hn') || this.currentLocation.includes('/dehradun-hn') || this.currentLocation.includes('/ganjam-nayagarh-puri-hn') || this.currentLocation.includes('/saraikela-hn') || this.currentLocation.includes('/sundergarh-hn') || this.currentLocation.includes('/dakshin-kannada-hn') || this.currentLocation.includes('/giridih-dhanbad-hn') || this.currentLocation.includes('/raisen-shajapur-sehore-hn') || this.currentLocation.includes('/mirzapur-hn') || this.currentLocation.includes('/bengaluru-hn') || this.currentLocation.includes('/dewas-hn') || this.currentLocation.includes('/media-kit-hn') || this.currentLocation.includes('/press-release-hn') || this.currentLocation.includes('/media-coverage-hn') || this.currentLocation.includes('/media-contact-hn') || this.currentLocation.includes('/media-events-hn') || this.currentLocation.includes('/commercial-hn') || this.currentLocation.includes('/industrial-hn') || this.currentLocation.includes('/application-procedure-hn') || this.currentLocation.includes('/rti-hn') || this.currentLocation.includes('/code-of-conduct-hn') || this.currentLocation.includes('/faq-hn') || this.currentLocation.includes('/disclaimer-hn') || this.currentLocation.includes('/operation-hn') || this.currentLocation.includes('/vendor-zone-hn') || this.currentLocation.includes('/customer-zone-hn') || this.currentLocation.includes('/investor-zone-hn') || this.currentLocation.includes('/annual-reports-hn') || this.currentLocation.includes('/brochure-hn') || this.currentLocation.includes('/policies-hn') || this.currentLocation.includes('/hse-policy-hn') || this.currentLocation.includes('/leakage-hn') || this.currentLocation.includes('/safety-guidelines-hn') || this.currentLocation.includes('/transport-hn') || this.currentLocation.includes('/savings-calculator-hn') || this.currentLocation.includes('/presence-hn')) {
      lang = 'hn';
    } else if (this.currentLocation.includes('/ganjam-nayagarh-puri-od') || this.currentLocation.includes('/sundergarh-od')) {
      lang = 'od';
    } else if (this.currentLocation.includes('/bengaluru-kn') || this.currentLocation.includes('/dakshin-kannada-kn')) {
      lang = 'kn';
    }
    else {
      lang = 'en';
    }
    localStorage.setItem('language', lang);
  }

  cng_rates() {
    this.operationService.cng_rates_fun({}).subscribe((res: any) => {
      let cngRateCard = res.data
      localStorage.setItem("cng_rates", JSON.stringify(cngRateCard));
    })
  }
  png_rates() {
    this.operationService.png_rates_fun({}).subscribe((res: any) => {
      let pngRateCard = res.data
      localStorage.setItem("png_rates", JSON.stringify(pngRateCard));
      let storedNames = JSON.parse(localStorage.getItem("png_rates"));
    })
  }


  ngOnInit(): void {


    AOS.init({
      duration: 1000,
      offset: 100
    });

    this.titleService.setTitle(this.title);
    this.metaTagService.updateTag(
      { name: 'description', content: 'GAIL Gas Limited - India’s Leading CGD Company' }
    );
    this.metaTagService.addTags([
      { name: 'keywords', content: '' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Dataevolve' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '2021-03-29', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' }
    ]);








    document.getElementById("exampleModal");
    // Scroll to top
    if ($('#back-to-top').length) {
      var scrollTrigger = 100, // px
        backToTop = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > scrollTrigger) {
            $('#back-to-top').addClass('show');
          } else {
            $('#back-to-top').removeClass('show');
          }
        };
      backToTop();
      $(window).on('scroll', function () {
        backToTop();
      });
      $('#back-to-top').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
    }


    if (
      this.currentLocation == '/privacy-policy'
    ) {

    } else {
      this.openDialog();
    }


  }
  openDialog(firstTime = true) {
    if (!firstTime) {
      this.hide_popup_aftertime = false;
    }
   // const dialogRef = this.dialog.open(DialogContentExampleDialog);
    const dialogRef = this.dialog.open(DialogContentExampleDialog, {
      panelClass: 'custom-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
    $('.custom-modalbox').parent().addClass('custom-modal');

    // Close the dialog after 10 seconds
    setTimeout(() => {
      if (this.hide_popup_aftertime) {
        dialogRef.close();
      }
    }, 10000);
  }

  ngAfterViewChecked() {
    this.PdfService.footer.subscribe((res) => {
      this.flag = true;
    });
    this.cdRef.detectChanges();
  }
}

@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: 'dialog-content-example-dialog.html',
})
export class DialogContentExampleDialog {
  event_list: { img: string; }[];
  language: any;

  constructor(public dialogRef: MatDialogRef<DialogContentExampleDialog>, public translateService: TranslateService) {
    this.event_list = [
      {
        img: './../../assets/gileModule/overview/banner-introduction.jpg',
      },
      {
        img: './../../assets/gileModule/overview/banner-our-people.jpg',
      }
    ];
  }

  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    this.translateService.setDefaultLang(this.language);
  }



  close(): void {
    this.dialogRef.close();
  }


}

